import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { AuthGuard } from './guards/auth.guard';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
      },
      {
        path: 'loginexpired',
        loadChildren: () => import('../app/component/login-vencido/login-vencido.component').then(m => m.LoginVencidoComponent)
      },
    ]
  },
 
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'component',
        loadChildren: () => import('./component/component.module').then(m => m.ComponentsModule)
      },
      
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'facturacionVentas',
        loadChildren: () => import('./facturacion-ventas/facturacion-ventas.module').then(m => m.FacturacionVentasModule)
      },
      {
        path: 'mantenimiento',
        loadChildren: () => import('./mantenimiento/mantenimiento.module').then(m => m.MantenimientoModule)
      },
      {
        path: 'contabilidad',
        loadChildren: () => import('./contabilidad/contabilidad.module').then(m => m.ContabilidadModule)
      },
      {
        path: 'inventario-servicios',
        loadChildren: () => import('./inventario-servicios/inventario-servicios.module').then(m => m.InventarioServiciosModule)
      },
      {
        path: 'ordenes-compra',
        loadChildren: () => import('./ordenes-compra/ordenes-compra.module').then(m => m.OrdenesCompraModule)
      },
      {
        path: 'cuentas-por-cobrar',
        loadChildren: () => import('./cuentas-por-cobrar/cuentas-por-cobrar.module').then(m => m.CuentasPorCobrarModule)
      }, {
        path: 'cuentas-por-pagar',
        loadChildren: () => import('./cuentas-por-pagar/cuentas-por-pagar.module').then(m => m.CuentasPorPagarModule)
      },
      {
        path: 'bancos',
        loadChildren: () => import('./bancos/bancos.module').then(m => m.BancosModule)
      },  {
        path: 'impuestos',
        loadChildren: () => import('./impuestos/impuestos.module').then(m => m.ImpuestosModule)
      },
      {
        path: 'autorizador',
        loadChildren: () => import('./autorizador/autorizador.module').then(m => m.AutorizadorModule)
      },
      {
        path: 'reportes',
        loadChildren: () => import('./reportes/reportes.module').then(m => m.ReportesModule)
      },
      {
        path: 'eventoSocial',
        loadChildren: () => import('./evento-social/evento-social.module').then(m => m.EventoSocialModule)
      },
      {
        path: 'seguridad',
        loadChildren: () => import('./seguridad/seguridad.module').then(m => m.SeguridadModule)
      }

    ]
  },
  {
    path: '**',
    redirectTo: '404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes), NgbModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
